import { render } from "./CrearRoles.vue?vue&type=template&id=5ed9bcac"
import script from "./CrearRoles.vue?vue&type=script&lang=js"
export * from "./CrearRoles.vue?vue&type=script&lang=js"

import "./CrearRoles.vue?vue&type=style&index=0&id=5ed9bcac&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__